module.exports = __webpack_public_path__ + "img/steffen.a89d69e7.svg";